import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IdentityService } from './identity.service';



@Injectable()
export class IdentityGuard  {
  constructor(
    private authService: IdentityService,
  ) { console.debug("AuthGuard constructed") }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$
      .pipe(
        tap(x => 
            console.log('You tried to go to ' + state.url + ' and this guard said ' + x)
          )
        );
  }
}